module.exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "O valor tem de ser ".concat(args.maxValue, " ou anterior.");
  },
  "rangeReversed": "A data de in\xEDcio deve ser anterior \xE0 data de fim.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "O valor tem de ser ".concat(args.minValue, " ou posterior.");
  },
  "unavailableDate": "Data selecionada indispon\xEDvel."
};